interface WindowPersistentCache {
  [key: string]: unknown;
}

const loggingEnabled = false;

function getWindowPersistentCache(): WindowPersistentCache {
  if (typeof globalThis.window === "undefined") {
    return {};
  }

  const win = globalThis.window as any;

  if (!("__PERSISTENT_STORE__" in win)) {
    win.__PERSISTENT_STORE__ = {};
  }

  return win.__PERSISTENT_STORE__ as WindowPersistentCache;
}

export function getWindowPersistentValue<T>(key: string, defaultValue: T): T {
  if (typeof globalThis.window === "undefined") {
    return defaultValue;
  }

  const cache = getWindowPersistentCache();

  if (!(key in cache)) {
    cache[key] = defaultValue;
  }

  if (loggingEnabled) {
    console.log("getWindowPersistentStore", key, cache[key]);
  }

  return cache[key] as T;
}

export function setWindowPersistentValue<T>(key: string, value: T) {
  if (typeof globalThis.window === "undefined") {
    return;
  }
  const cache = getWindowPersistentCache();

  cache[key] = value;
  if (loggingEnabled) {
    console.log("setWindowPersistentStore", key, value);
  }
}
